import { Link } from "react-router-dom";
import { EmptyState } from "../components/EmptyState";

export function NotFoundPage() {
  return (
    <div className="container" style={{ paddingBlock: "3rem" }}>
      <EmptyState
        title="Nothing on this radar"
        actions={
          <>
          <Link to="/brands"><button className="primary">Browse brands</button></Link>
          <Link to="/categories"><button>View categories</button></Link>
          </>
        }
      >
        That page is not live, or the signal moved.
      </EmptyState>
    </div>
  );
}
